callpy_global.CFlash = function()
{
    this.module_name = "Flash ";
    this.module_log_rang = 100;
    this.PeerConnection = null;
    this.IceCandidate = null;
    this.SessionDescription = null;
    this.pc = null; // PeerConnection
    this.pc_config = null;
    this.stream = null;
    this.audiostream = null;
    this.remotestream = null;
    this.audio = false;
    this.video = false;
    this.video_support = false;
    this.connected_to_rp = false;
    this.webRTCsupp = 0;
    this.call_type = null;
    this.stateTimer = null;
    this.pingTimer = null;
    this.pingRequestTimer = null;
    this.disconnectLimit = 5000; //количество миллисекунд, после которых дисконнектим
    this.pingLimit = 10000; //то же, но для системы пинга, а не oniceconnetionchange
    this.pingCount = 0; //количество неудачных пингов подряд
    this.currentClient = null; //клиент, с которым в данный момент идет дозвон / звонок
    this.currentSiteId = null; //клиент, с которым в данный момент идет дозвон / звонок

    this.dialupTimer = null;
    this.dialupLimit = 25000; //лимит дозвона - 25 секунд
    this.webRTCtype = (navigator.mozGetUserMedia?'firefox':'chrome');
    this.peer_webRTCtype = null;
    this.access_equip = false; //флаг, указывающий на состояние запроса доступа к оборудованию
    this.iceCandidateBuffer = []; //буфер для хранения пришедших iceCandidate (необходим, т.к. иногда сообщения о icecandidate приходят раньше, чем descriprion)
    this.receivedDescription = false; //получали ли description от собеседника
    this.videostream = null; //только для firefox
    //this.lastRealplexorMessages= {}; //Объект, содержащий для каждого типа action время последнего обработанного сообщения для предотвращения выполнения старых сообщений (не по порядку) для некоторых типов
    //например, для go_url
    if ((window.mozRTCPeerConnection || window.webkitRTCPeerConnection || window.RTCPeerConnection) && (navigator.userAgent.indexOf("Chrome/") != -1 || navigator.userAgent.indexOf("Firefox/") != -1 || navigator.getUserMedia || navigator.mozGetUserMedia || (navigator.mediaDevices && navigator.mediaDevices.getUserMedia))) this.webRTCsupp = 1;

    var _this = this;

    this.flash_path = callpy_global.php_server + "swf/";
    this.nsp = null;

    this.load_flash_complete = function ()
    {
        m_callpy.m_bridge.flash_object = document.getElementById("callpy_access_to_equip_flash");
    }

    this.connect_to_fms = function ()
    {

        if (!_this.connected_to_rp){

            //в этот момент уже доступен объект m_callpy.client_data.browser с данными об используемом браузере клиента (получаем его при запросе инициализации от сервера)
            if (m_callpy.client_data.browser && m_callpy.client_data.browser[0] && m_callpy.client_data.browser[0] == "Safari") _this.webRTCtype = "Safari";
            _this.connected_to_rp = true;

            if (m_callpy.client_data.site) _this.nsp = m_callpy.realplexor.get_namespace_rpx(m_callpy.client_data.site_id, m_callpy.client_data.site);
            else{
                //TODO: здесь костыль, сделать нормально определение демо-консультанта
                _this.nsp = "callpy";
                for (var key in m_callpy.client_data.site_info){
                    _this.nsp = m_callpy.realplexor.get_namespace_rpx(m_callpy.client_data.site_id, m_callpy.client_data.site_info[key].domain);
                    break;
                }
            }
            m_callpy.realplexor.init("https://rp."+callpy_global.callpy_domain,_this.nsp);

            if (m_callpy.client_data.type!=2){
                if (localStorage.getItem("callpy_cid")==null){
                    m_callpy.realplexor.setCursor( m_callpy.client_data.site_id + "_" +((m_callpy.client_data.type == 1) ? "c_" : "m_") + m_callpy.client_data.key + "_" + m_callpy.client_data.channel,m_callpy.client_data.timestamp);
                    //UPDATED: каналы диалогов
                    if (m_callpy.client_data.dialogs){
                        for (var i in m_callpy.client_data.dialogs){
                            if (m_callpy.client_data.dialogs[i]["status"] == 0) continue;
                            m_callpy.realplexor.setCursor("dialog_" + m_callpy.client_data.dialogs[i]["id"] + "_" + m_callpy.client_data.dialogs[i]["channel"], m_callpy.client_data.timestamp);
                        }
                    }
                    //для предотвращения потери сообщение ввиду отсутствия значения callpy_cid, запишем серверное время
                    localStorage.setItem("callpy_cid", m_callpy.client_data.timestamp);
                }
                else {
                    m_callpy.realplexor.setCursor( m_callpy.client_data.site_id + "_" + ((m_callpy.client_data.type == 1) ? "c_" : "m_") + m_callpy.client_data.key + "_" + m_callpy.client_data.channel,parseFloat(localStorage.getItem("callpy_cid"))+0.001);
                    //UPDATED: каналы диалогов
                    if (m_callpy.client_data.dialogs){
                        for (var i in m_callpy.client_data.dialogs){
                            if (m_callpy.client_data.dialogs[i]["status"] == 0) continue;
                            m_callpy.realplexor.setCursor("dialog_" + m_callpy.client_data.dialogs[i]["id"] + "_" + m_callpy.client_data.dialogs[i]["channel"], parseFloat(localStorage.getItem("callpy_cid"))+0.001);
                        }
                    }
                }
                m_callpy.realplexor.subscribe( m_callpy.client_data.site_id + "_" + ((m_callpy.client_data.type == 1) ? "c_" : "m_") + m_callpy.client_data.key + "_" + m_callpy.client_data.channel,
                    function(data, id, cursor) {
                        data = JSON.parse(data);
                        //if (data["action"] && _this.lastRealplexorMessages[data["action"]] && _this.lastRealplexorMessages[data["action"]] > parseFloat(cursor) && data["action"] == "go_url"){

                        //}else{
                        //    if (data["action"]){
                        //        _this.lastRealplexorMessages[data["action"]] = parseFloat(cursor);
                        //    }
                        localStorage.setItem("callpy_cid", cursor);
                        localStorage.setItem("callpy_lastRpx", new Date().getTime());
                        //_this.connected_to_rp = true;
                        m_callpy.m_bridge.from_flash(data);
                        //}


                    });
                //UPDATED: каналы диалогов
                if (m_callpy.client_data.dialogs){
                    for (var i in m_callpy.client_data.dialogs){
                        if (m_callpy.client_data.dialogs[i]["status"] == 0) continue;
                        m_callpy.realplexor.subscribe("dialog_" + m_callpy.client_data.dialogs[i]["id"] + "_" + m_callpy.client_data.dialogs[i]["channel"],
                        function(data, id, cursor) {
                            data = JSON.parse(data);
                            //получим id диалога из id канала:
                            var tmp = id.split("_");
                            tmp = tmp[1];
                            data["dialog_id"] = tmp;
                            localStorage.setItem("callpy_cid", cursor);
                            localStorage.setItem("callpy_lastRpx", new Date().getTime());
                            m_callpy.m_bridge.from_flash(data);
                        });
                    }
                }
            }else{
                //для консультанта: он должен подписаться на все каналы сайтов, которыми оперирует консультант, и на собственный канал

                //для каждого канала запоминаем момент получения последнего сообщения
                if (localStorage.getItem("callpy_mcid")==null){
                    localStorage.setItem("callpy_mcid", JSON.stringify({}));
                }
                m_callpy.m_manager.cids = JSON.parse(localStorage.getItem("callpy_mcid"));

                var chnl;

                for (var key in m_callpy.client_data.channel)
                {
                    if (key=="manager"){

                        chnl = "manager_"+m_callpy.client_data.key + "_" + m_callpy.client_data.channel[key];
                        //канал консультанта
                        if (!m_callpy.m_manager.cids[key] || (new Date().getTime()/1000 - m_callpy.m_manager.cids[key]>15)) m_callpy.realplexor.setCursor( chnl,m_callpy.initialize_data.timestamp);
                        else m_callpy.realplexor.setCursor( chnl, parseFloat(m_callpy.m_manager.cids[key])+0.001);
                        m_callpy.realplexor.subscribe( chnl,
                            function(data, id, cursor) {
                                data = JSON.parse(data);
                                m_callpy.m_manager.cids["manager"] = cursor;
                                localStorage.setItem("callpy_mcid", JSON.stringify(m_callpy.m_manager.cids));
                                m_callpy.m_manager.from_rlpx(data);
                            });

                    }else{

                        chnl = key + "_m_" + m_callpy.client_data.key + "_" + m_callpy.client_data.channel[key];

                        //подписываемся только в случае, если callpy включен (status==1)
                        if (m_callpy.client_data.site_info[key].status=="1"){

                            if (!m_callpy.m_manager.cids[key]) m_callpy.realplexor.setCursor( chnl,m_callpy.initialize_data.timestamp);
                            else m_callpy.realplexor.setCursor( chnl, parseFloat(m_callpy.m_manager.cids[key])+0.001);
                            m_callpy.realplexor.subscribe( chnl,
                                function(data, id, cursor) {
                                    data = JSON.parse(data);
                                    //получим id сайта из id канала:
                                    var tmp = id.split("_");
                                    tmp = tmp[0].replace(_this.nsp,"");
                                    m_callpy.m_manager.cids[tmp] = cursor;
                                    localStorage.setItem("callpy_mcid", JSON.stringify(m_callpy.m_manager.cids));
                                    data["site_id"] = tmp; //TODO: Важно! Во все сообщения из канала автоматически добавляется site_id, чтобы удобно было прочесть
                                    m_callpy.m_bridge.from_flash(data);
                                });

                        }

                    }

                }

                //UPDATED: каналы мультидиалогов
                if (m_callpy.initialize_data.multidialogs && m_callpy.initialize_data.multidialogs){
                    for (var i in m_callpy.initialize_data.multidialogs){
                        if (m_callpy.initialize_data.multidialogs[i]["status"] == 0) continue;
                        chnl = "dialog_" + m_callpy.initialize_data.multidialogs[i]["id"] + "_" + m_callpy.initialize_data.multidialogs[i]["channel"];
                        if (!m_callpy.m_manager.cids["dialog_" + m_callpy.initialize_data.multidialogs[i]["id"]]) m_callpy.realplexor.setCursor( chnl,m_callpy.initialize_data.timestamp);
                        else m_callpy.realplexor.setCursor( chnl, parseFloat(m_callpy.m_manager.cids["dialog_" + m_callpy.initialize_data.multidialogs[i]["id"]])+0.001);

                        m_callpy.realplexor.subscribe( chnl,
                            function(data, id, cursor) {
                                data = JSON.parse(data);
                                //получим id диалога из id канала:
                                var tmp = id.split("_");
                                tmp = tmp[1];
                                m_callpy.m_manager.cids["dialog_" + tmp] = cursor;
                                localStorage.setItem("callpy_mcid", JSON.stringify(m_callpy.m_manager.cids));
                                data["dialog_id"] = tmp; //TODO: Важно! Во все сообщения из канала автоматически добавляется dialog_id, чтобы удобно было прочесть
                                m_callpy.m_bridge.from_flash(data);
                            });

                    }
                }

            }

            m_callpy.realplexor.execute();

        }

    }

    this.isConnectedToRpx = function (){
        return (new Date().getTime() - localStorage.getItem("callpy_lastRpx")<30000);
    }

    this.start_flash = function(params){
        _this.call_type = "flash";

        _this.access_equip = true;

        if (swfobject.hasFlashPlayerVersion("10")){

            params = params ? params : {};

            params.flash_name = params.flash_name ? params.flash_name : _this.flash_path + "callpyFlash.swf";
            params.flash_place = params.flash_place ? params.flash_place : "callpy_access_to_equip_flash";
            params.flash_width = params.flash_width ? params.flash_width : "215";
            params.flash_height = params.flash_height ? params.flash_height : "138";
            params.flash_version = params.flash_version ? params.flash_version : "9.0.0";
            params.flash_install = params.flash_install ? params.flash_install : "playerProductInstall.swf";
            params.flash_vars = params.flash_vars ? params.flash_vars : {};
            params.flash_params = params.flash_params ? params.flash_params : {};
            params.flash_params.wmode = params.flash_params.wmode ? params.flash_params.wmode : "opaque";
            params.flash_params.allowscriptaccess = params.flash_params.allowscriptaccess ? params.flash_params.allowscriptaccess : "always";
            params.flash_params.embed = params.flash_params.embed ? params.flash_params.embed : "callpy_access_to_equip_flash";
            params.flash_attribs = params.flash_attribs ? params.flash_attribs : {};
            params.flash_on_load = params.flash_on_load ? params.flash_on_load : _this.load_flash_complete;

            swfobject.embedSWF(
                params.flash_name,
                params.flash_place,
                params.flash_width,
                params.flash_height,
                params.flash_version,
                params.flash_install,
                params.flash_vars,
                params.flash_params,
                params.flash_attribs,
                params.flash_on_load);

        }else{

            //Flash плеер не установлен
            //TODO GUI: системное сообщение в чат
            _this.access_equip = false;
            $jcallpy('#callpy_access_to_equip_overlay_flash').css('left', '-3000px');
            localStorage.removeItem("callpy_call_flag");
            m_callpy.m_chat.call_status = "no_call";

            //$jcallpy.call('out_cancel', 'Для звонка необходим Flash Player!');
            $jcallpy('#callpy_call_button_call').show();
            $jcallpy('#callpy_call_button_connection').hide();

        }


    }


    this.end_flash = function(){
        if (m_callpy.m_chat.call_status == "call"){
            m_callpy.m_bridge.flash_object.to_flash("to_flash",{action: "end_call"}); //если шел звонок, отправляем сообщение флешке прекратить звонок
        }
        m_callpy.m_chat.call_status = "no_call";
        if (m_callpy.m_user) m_callpy.m_chat.save_state = 0;
        swfobject.removeSWF("callpy_access_to_equip_flash");
        m_callpy.m_bridge.flash_object = null;
        $jcallpy('#callpy_access_to_equip_overlay_flash').remove();
    }

    this.start_webrtc = function(audio, video){
        _this.call_type = "webrtc";
        _this.PeerConnection = window.mozRTCPeerConnection || window.webkitRTCPeerConnection || window.RTCPeerConnection;
        _this.IceCandidate = window.mozRTCIceCandidate || window.RTCIceCandidate;
        _this.SessionDescription = window.mozRTCSessionDescription || window.RTCSessionDescription;
        navigator.getUserMedia = navigator.getUserMedia || navigator.mozGetUserMedia || navigator.webkitGetUserMedia || navigator.mediaDevices.getUserMedia;

        _this.audio = true;
        _this.video = false;

        _this.video_support = true;

        _this.access_equip = true;
        navigator.getUserMedia(
            { audio: true, video: false },
            _this.gotStream,
            function(error) {
                _this.access_equip = false;
                //TODO: в случае, если нам звонили, необходимо отправить пиру сообщение об отказе от звонка
                //m_callpy.m_chat.save_state = 0;
                var call_flag = localStorage.getItem("callpy_call_flag");
                m_callpy.m_chat.call_status = "no_call";
                if (call_flag=="2"){
                    //$jcallpy.callpy_status('set', 'dial_off', true);
                    $jcallpy.callpy_status('set', 'equip_mic_off', true);
                }else if (call_flag=="1"){
                    //$jcallpy.callpy_status('set', 'incoming_call_off', true);
                    $jcallpy.callpy_status('set', 'equip_mic_off', true);
                    m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("end_dialup"));
                }
                localStorage.removeItem("callpy_call_flag");
                //$jcallpy("#callpy_access_to_equip_overlay").remove();
                //ошибка при попытке получить доступ к камере и микрофону. Пытаемся только к микрофону, если ошибка "не найдено устройство":
                if (error.name=="DevicesNotFoundError"){

                    alert(_("Для звонка необходим микрофон!"));

                }else{

                    if (error.message.indexOf("secure origins")===false) alert(_("Ошибка доступа к микрофону! Возможно, микрофон занят другим приложением. Закройте все приложения и повторите попытку."));
                    else alert(_("Для доступа к микрофону в браузере Chrome требуется защищенный протокол https. К сожалению, данный сайт его не поддерживает, вы можете использовать для звонка, например, Firefox."));

                }

            }
        );




    }

    this.gotStream = function(stream){
        _this.access_equip = false;

        //todo: flat
        //$jcallpy("#callpy_access_to_equip_overlay").remove();
        //$jcallpy(document.body).removeClass('callpy_access_equip_overlay');

        if (m_callpy.m_user){
            var call_flag = localStorage.getItem("callpy_call_flag");
            //FIXED: пока разрешали доступ к оборудованию, дозвон мог прекратиться (если нам звонил менеджер)
            //И еще случай, когда флаг мог быть в состоянии звонка: при входящем звонке нажали "принять" на многих вкладках, и на одной разрешили доступ - на остальных остался висеть доступ, можно нажать
            if (!call_flag) {
                if (_this.pc) _this.pc.close();
                stream.getTracks().forEach(function(e){e.stop()});
                //stream.stop();

                _this.pc = null;
                _this.stream = null;
                stream = null;
                _this.remotestream = null;
                return;
            }

            //вместо вызова функции проверять прямо здесь, звонит ли клиент, или отвечает на входящий звонок менеджера (чтобы сразу же после создания потоков можно было начать разговор)
            if (call_flag == "2"){ //звонит клиент
                //исходящий звонок изменения в UI.
                //$jcallpy.callpy_call('out');
                $jcallpy.callpy_status('set', 'dial_on', true);
                m_callpy.m_chat.call_status = "calling_to_manager";
            }else{

                //FIXED: ранее флаг выставлялся по клику "ответить" сразу
                if (m_callpy.m_storage.restoreInIE) m_callpy.m_storage.handleCallFlag = false;
                localStorage.setItem("callpy_call_flag",3);

                //m_callpy.m_chat.call_status = "call";
                //localStorage.setItem("callpy_call_flag",3);
                m_callpy.m_chat.answer({noOffer: true});
                //m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("chat_answ", {0: true, 1: false}));
            }
        }else if (m_callpy.m_manager){
            $jcallpy("#callpy_access_to_equip_overlay").remove();
            $jcallpy(document.body).removeClass('callpy_access_equip_overlay');
            //FIXED: то же, что и у клиента выше
            if (m_callpy.m_chat.call_status=="no_call" || m_callpy.m_chat.call_status=="call") return;

            //необходимо обрабатывать в зависимости от того, отвечает менеджер на входящий звонок или звонит сам

            //TODO: логику необходимо переписать
            //TODO: call_status == 'no_call', когда звонка нет, или нам звонят, но мы не приняли
            //TODO: call_status == 'calling_to_manager' или 'calling_to_client', когда мы начинаем дозвон
            //TODO: call_status == 'call', когда звонок состоялся
            //TODO: следовательно, здесь должна быть проверка call_status == 'no_call' (нам звонят)
            //if (m_callpy.m_chat.call_status=="audio_call_from_client"|| m_callpy.m_chat.call_status=="video_call_from_client"){
            //if (m_callpy.m_chat.call_status=="no_call"){
            if (m_callpy.m_chat.call_status=="incoming"){ //входящий

                //m_callpy.m_bridge.to_peer(
                //    m_callpy.m_message.create_message("chat_answ", {0: true, 1: false}));
                //m_callpy.m_bridge.to_flash(m_callpy.m_message.create_message("update_call_set", {0: true, 1: tmp}));

                //TODO: вызов функций для UI (сменить статус клиента, отрисовать окно вызова)
                //m_callpy.users_list[m_callpy.client_data.peer_key].isActive = 0;
                $jcallpy.chat('accept_call', {id: m_callpy.client_data.peer_key, site_id: m_callpy.client_data.site_id});
                //st_call = true;

                //m_callpy.m_chat.start_call(tmp);

            }else if (m_callpy.m_chat.call_status=="calling_to_client"){ //мы звоним
                $jcallpy.chat('start_call');
            }


        }

        //TODO: для FireFox в url необходимо передавать ТОЛЬКО адрес без username, а username - отдельно!!!

        var iceServers = [/*{url:'stun:stun01.sipphone.com'},
            {url:'stun:stun.ekiga.net'},
            {url:'stun:stun.fwdnet.net'},
            {url:'stun:stun.ideasip.com'},
            {url:'stun:stun.iptel.org'},
            {url:'stun:stun.rixtelecom.se'},
            {url:'stun:stun.schlund.de'},
            */
            {url:'stun:stun.l.google.com:19302'},
            /*
            {url:'stun:stun1.l.google.com:19302'},
            {url:'stun:stun2.l.google.com:19302'},
            {url:'stun:stun3.l.google.com:19302'},
            {url:'stun:stun4.l.google.com:19302'},
            {url:'stun:stunserver.org'},
            {url:'stun:stun.softjoys.com'},
            {url:'stun:stun.voiparound.com'},
            {url:'stun:stun.voipbuster.com'},
            {url:'stun:stun.voipstunt.com'},
            {url:'stun:stun.voxgratia.org'},
            {url:'stun:stun.xten.com'},
            */
            {
                url: 'turn:numb.viagenie.ca',
                credential: 'Qwerty12345',
                username: 'dizzy@civa.ru'
            }/*,
            {
                url: 'turn:192.158.29.39:3478?transport=udp',
                credential: 'JZEOEt2V3Qb0y27GRntt2u2PAYA=',
                username: '28224511:1379330808'
            },
            {
                url: 'turn:192.158.29.39:3478?transport=tcp',
                credential: 'JZEOEt2V3Qb0y27GRntt2u2PAYA=',
                username: '28224511:1379330808'
            }*/];

        //_this.pc_config = {"iceServers": iceServers};
        _this.pc_config = {"iceServers": [{"urls": "turn:"+"callpy.com"+":3478", "username": "dimaadmin", "credential": "Xvm7djqiYhXnTAWA"}, {"urls": "stun:"+"callpy.com"+":3478"}]};
        //_this.config = {};
        //_this.pc_config = {"iceServers": [{"url": "turn:"+callpy_global.callpy_domain+":3478", "username": "dimaadmin", "credential": "Xvm7djqiYhXnTAWA"}, {"url": "stun:devcallpy.ru:19302"}]};
        //if (typeof window.webkitRTCPeerConnection != "undefined") _this.pc_config = {"iceServers": [{"url": "turn:dimaadmin@"+callpy_global.callpy_domain+":3478", "credential": "Xvm7djqiYhXnTAWA"}, {"url": "stun:stun.l.google.com:19302"}]};
        //else _this.pc_config = {"iceServers": [{"url": "turn:"+callpy_global.callpy_domain+":3478", "username": "dimaadmin", "credential": "Xvm7djqiYhXnTAWA"}, {"url": "stun:stun.l.google.com:19302"}]};
        //if (typeof window.webkitRTCPeerConnection != "undefined") _this.pc_config = {"iceServers": [{"url": "turn:dimaadmin@"+callpy_global.callpy_domain+":3478", "credential": "Xvm7djqiYhXnTAWA"}, {"url": "stun:stun.l.google.com:19302"}]};
        //else _this.pc_config = {"iceServers": [{"url": "turn:"+callpy_global.callpy_domain+":3478", "username": "dimaadmin", "credential": "Xvm7djqiYhXnTAWA"}, {"url": "stun:stun.l.google.com:19302"}]};

        _this.pc = new _this.PeerConnection(_this.pc_config, undefined);

        _this.stream = stream;
        _this.receivedDescription = false;

        _this.pc.addStream(_this.stream);

        _this.pc.onicecandidate = _this.gotIceCandidate;
        _this.pc.onaddstream = _this.gotRemoteStream;

        //для отслеживания некорректного завершения соединения в chrome. В Firefox не работает (соединение не уходит в "disconnected")
        //_this.pc.oniceconnectionstatechange = _this.iceStateChanged;

        //_this.pc.onclosedconnection = function() {m_callpy.m_logger.log("CONNECTION CLOSED!")};
        //_this.pc.oniceconnectionstatechange = function () {m_callpy.m_logger.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!"+_this.pc.iceConnectionState);if ((_this.pc.iceConnectionState=="connected" || _this.pc.iceConnectionState=="completed") && _this.stream.getVideoTracks().length > 0) _this.stream.getVideoTracks()[0].enabled = false; };
        //_this.pc.on('addStream', _this.gotRemoteStream);
        //_this.pc.onclose = function() {alert("Closed!");};
        _this.pc.oniceconnectionstatechange = function () {
            if (!_this.pc) return;
            if ((_this.pc.iceConnectionState=="connected" || _this.pc.iceConnectionState=="completed")){
                if (m_callpy.m_manager){
                    if (document.getElementById("callpy_webrtc_video_tag").srcObject !== undefined){
                        document.getElementById("callpy_webrtc_video_tag").srcObject = _this.pc.getRemoteStreams()[0];
                    }else{
                        document.getElementById("callpy_webrtc_video_tag").src = URL.createObjectURL(_this.pc.getRemoteStreams()[0]);
                    }
                }else{
                    if (document.getElementById("callpy_client_video").srcObject !== undefined){
                        document.getElementById("callpy_client_video").srcObject = _this.pc.getRemoteStreams()[0];
                    }else{
                        document.getElementById("callpy_client_video").src = URL.createObjectURL(_this.pc.getRemoteStreams()[0]);
                    }
                }
                //if (m_callpy.m_manager) document.getElementById("callpy_webrtc_video_tag").src = URL.createObjectURL(_this.pc.getRemoteStreams()[0]);
                //else document.getElementById("callpy_client_video").src = URL.createObjectURL(_this.pc.getRemoteStreams()[0]);
                //if (m_callpy.m_manager) document.getElementById("callpy_webrtc_video_tag").srcObject = _this.pc.getRemoteStreams()[0];
                //else document.getElementById("callpy_client_video").srcObject = _this.pc.getRemoteStreams()[0];
            }
        };

        if (m_callpy.m_user){
            //вместо вызова функции проверять прямо здесь, звонит ли клиент, или отвечает на входящий звонок менеджера (чтобы сразу же после создания потоков можно было начать разговор)
            if (call_flag == "2"){
                m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("chat_call", {
                    "webRTC": 1,
                    "peerRTCType": _this.webRTCtype
                }));
                _this.dialupTimer = setTimeout(_this.autoEndDialup, _this.dialupLimit);
            }else{
                if (_this.peer_webRTCtype != _this.webRTCtype && _this.webRTCtype == "chrome"){
                    //Звонок из FF в Chrome - createOffer должен сделать Chrome
                    _this.createOffer();
                }
                m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("chat_answ", {
                    "peerRTCType": _this.webRTCtype
                }));
            }
        }else if (m_callpy.m_manager){

            //необходимо обрабатывать в зависимости от того, отвечает менеджер на входящий звонок или звонит сам
            if (m_callpy.m_chat.call_status=="incoming"){
                m_callpy.m_chat.call_status = 'call';
                if (_this.peer_webRTCtype != _this.webRTCtype && _this.webRTCtype == "chrome"){
                    //Звонок из FF в Chrome - createOffer должен сделать Chrome
                    _this.createOffer();
                }
                m_callpy.m_bridge.to_peer(
                    m_callpy.m_message.create_message("chat_answ", {
                        "peerRTCType": _this.webRTCtype
                    }));

            }else if (m_callpy.m_chat.call_status=="calling_to_client"){
                m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("chat_call", {
                    "webRTC": 1,
                    "peerRTCType": _this.webRTCtype
                }));
                _this.dialupTimer = setTimeout(_this.autoEndDialup, _this.dialupLimit);
            }


        }
        //создаем систему пинга для отлова дисконнекта уже в момент создания потока, т.к. необходимо сделать обработку во всех случаях (и если шел только дозвон)
        _this.start_ping();
        _this.pingCount = 0;

    }

    //отлавливаем некорректное завершение вызова
    /*
    this.iceStateChanged = function(){
        clearTimeout(_this.stateTimer);
        if (_this.pc && (_this.pc.iceConnectionState=="failed" || _this.pc.iceConnectionState=="disconnected" || _this.pc.iceConnectionState=="closed")){
            _this.stateTimer = setTimeout(function(){
                //при корректном завершении peerConnection будет удалено. Если не удалилось, завершение не произошло
                if (_this.pc){
                    //некорректно завершился вызов (например, прервалась связь)
                    if (m_callpy.m_manager){
                        m_callpy.m_chat.end_call_from_peer(); //как будто пришло сообщение об отмене звонка
                    }else{
                        m_callpy.m_chat.end_call_from_peer(); //как будто пришло сообщение об отмене звонка
                    }
                }

            }, _this.disconnectLimit);
        }
    }
    */

    //начинаем пинговать клиента пира n секунд
    this.start_ping = function(){
        m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("ping", {
            "pingtype": "request"
        }));
        _this.pingTimer = setTimeout(_this.ping_failed, _this.disconnectLimit);
    }

    //нам приходит запрос на пинг, необходимо послать ответ (но только если идет разговор или входящий вызов - для клиента)
    this.ping_request = function(data){
        if (!data["peer"]) data["peer"] = {type: "peer", part_id: m_callpy.client_data.peer_key, part_site_id: m_callpy.client_data.site_id};
        if (m_callpy.m_manager){
            //у менеджера особый случай: запрос на пинг может прийти не от выбранного клиента (а от того, кто начал дозвон)
            if (m_callpy.m_manager.isClientSelected(data["site_id"], data["key"])){
                if (m_callpy.m_chat.call_status == "call" || m_callpy.m_chat.call_status == "incoming")
                    m_callpy.m_bridge.to_peer_or_group({
                        action: "ping",
                        pingtype: "answer",
                        site_id: data["site_id"],
                        key: m_callpy.client_data.key,
                        type: 2,
                        peer_key: data["key"],
                        peer_type: 1,
                        domain: m_callpy.client_data.site_info[data["site_id"]].domain
                    }, data["peer"], null, true);
                //если клиент выбран у менеджера, то ответить на пинг надо только в случае, если идет входящий дозвон или звонок
                //if (m_callpy.m_chat.call_status == "call" || m_callpy.m_chat.call_status == "incoming") m_callpy.m_bridge.send_data("to_peer", {action: "ping", pingtype: "answer", site_id: m_callpy.client_data.site_id, key: m_callpy.client_data.key, type: 2, peer_key: data["key"], peer_type: 1, domain: m_callpy.client_data.site, where: "to_fms"});
            }else {
                //m_callpy.m_bridge.send_data("to_peer", {action: "ping", pingtype: "answer", site_id: data["site_id"], key: m_callpy.client_data.key, type: 2, peer_key: data["key"], peer_type: 1, domain: m_callpy.client_data.site_info[data["site_id"]].domain, where: "to_fms"});
                m_callpy.m_bridge.to_peer_or_group({
                    action: "ping",
                    pingtype: "answer",
                    site_id: data["site_id"],
                    key: m_callpy.client_data.key,
                    type: 2,
                    peer_key: data["key"],
                    peer_type: 1,
                    domain: m_callpy.client_data.site_info[data["site_id"]].domain
                }, data["peer"], null, true);
            }
        }else{
            var call_flag = localStorage.getItem("callpy_call_flag");
            if (call_flag == 3 || call_flag == 1){
                m_callpy.m_bridge.to_peer_or_group(m_callpy.m_message.create_message("ping", {
                    "pingtype": "answer"
                }), data["peer"]);
            }
        }

    };

    //пришел ответ на наш пинг-запрос, необходимо запланировать следующий
    this.ping_answer = function(){
        _this.pingCount = 0;
        clearTimeout(_this.pingTimer);
        clearTimeout(_this.pingRequestTimer);
        if ((m_callpy.m_user && (_this.pc || m_callpy.m_bridge.flash_object)) || (m_callpy.m_manager && ((_this.pc && _this.pc.signalingState != "closed")||m_callpy.m_bridge.flash_object))) _this.pingRequestTimer = setTimeout(_this.start_ping, _this.disconnectLimit); //только если не завершен звонок
    }

    //вызывается, если за заданное время не был получен ответ на наш пинг
    this.ping_failed = function(){
        //пока используем только для корректного завершеения звонка
        if (_this.pc){
            _this.pingCount++;
            if (_this.pingCount==3){ //считаем, что связи нет после 3-х неудачных пингов

                if (m_callpy.m_manager){
                    m_callpy.m_logger.warn("PING FAILED - MANAGER");
                    if (m_callpy.m_chat.call_status=="call") m_callpy.m_chat.end_call_from_peer(); //как будто пришло сообщение об отмене звонка
                    else{
                        m_callpy.m_chat.end_dialup_from_peer({key: m_callpy.m_manager.selected_user, site_id: m_callpy.client_data.site_id});
                        //TODO: а кому посылается сообщение об отмене дозвона? Может быть, у консультанта выбран вообще другой клиент. Закомментил
                        //TODO: поскольку функция PING_FAILED, то консультант не мог переключиться на другого клиента (во время дозвона или звонка нельзя)
                        m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("end_dialup")); //на всякий случай сообщение об отмене дозвона
                    }
                }else{
                    m_callpy.m_logger.warn("PING FAILED - CLIENT");
                    if (m_callpy.m_chat.call_status=="call") m_callpy.m_chat.end_call_from_peer(); //как будто пришло сообщение об отмене звонка
                    else{
                        m_callpy.m_chat.end_dialup_from_peer();
                        m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("end_dialup")); //на всякий случай сообщение об отмене дозвона
                    }
                }

            }else{
                m_callpy.m_logger.warn("NO ANSWER FOR PING REQUEST #"+_this.pingCount);
                //иначе - пытаемся еще раз
                _this.stop_ping();
                _this.start_ping();
            }
        }
    }

    //останавливаем пинг (необходимо вызывать при завершении звонка (корректном))
    this.stop_ping = function(){
        clearTimeout(_this.pingTimer);
        clearTimeout(_this.pingRequestTimer);
    }

    //Автоматически отклоняем дозвон при достижении лимита
    this.autoEndDialup = function(){
        $jcallpy("#callpy_button_call").trigger("click");
    }

    this.gotIceCandidate = function(event){
        if (event.candidate) {
            m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("icecandidate", {
                "label": event.candidate.sdpMLineIndex,
                "id": event.candidate.sdpMid,
                "candidate": event.candidate.candidate
            }));
        }
    }

    this.gotRemoteStream = function(event){
        m_callpy.m_logger.info("Got remote stream", event.stream);
        _this.remotestream = event.stream;
        //if (m_callpy.m_manager) document.getElementById("callpy_webrtc_video_tag").src = URL.createObjectURL(event.stream);
        //else document.getElementById("callpy_client_video").src = URL.createObjectURL(event.stream);
        //if (m_callpy.m_manager) document.getElementById("callpy_webrtc_video_tag").srcObject = event.stream;
        //else document.getElementById("callpy_client_video").srcObject = event.stream;
        if (m_callpy.m_manager){
            if (document.getElementById("callpy_webrtc_video_tag").srcObject !== undefined){
                document.getElementById("callpy_webrtc_video_tag").srcObject = _this.pc.getRemoteStreams()[0];
            }else{
                document.getElementById("callpy_webrtc_video_tag").src = URL.createObjectURL(_this.pc.getRemoteStreams()[0]);
            }
        }else{
            if (document.getElementById("callpy_client_video").srcObject !== undefined){
                document.getElementById("callpy_client_video").srcObject = _this.pc.getRemoteStreams()[0];
            }else{
                document.getElementById("callpy_client_video").src = URL.createObjectURL(_this.pc.getRemoteStreams()[0]);
            }
        }
    };

    this.gotLocalDescription = function(description){
        _this.pc.setLocalDescription(description);
        m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("description", {
            "descriptor": {
                "sdp": description.sdp,
                "type": description.type
            },
            "video": _this.video
        }));
    }

    this.createAnswer = function() {
        _this.pc.createAnswer(
            _this.gotLocalDescription,
            function(error) { m_callpy.m_logger.error(error) },
            //{ 'mandatory': { 'OfferToReceiveAudio': true, 'OfferToReceiveVideo': false } }
            undefined
        );
    }

    this.createOffer = function() {
        m_callpy.m_logger.info("Creating offer!!!");
        _this.pc.createOffer(
            _this.gotLocalDescription,
            function(error) { m_callpy.m_logger.error(error) },
            { 'mandatory': { 'OfferToReceiveAudio': true, 'OfferToReceiveVideo': true } }
            //undefined
        );
    }

    this.onoffer = function(data){
        //обрабатываем только на вкладке, где есть поток
        if (_this.pc){

            if (_this.webRTCtype=="firefox") data["descriptor"]["sdp"] = data["descriptor"]["sdp"].replace(/UDP\/TLS\//gi, "");
            _this.pc.setRemoteDescription(new _this.SessionDescription(data["descriptor"]), _this.createAnswer, function(error){m_callpy.m_logger.error(error)});
            _this.receivedDescription = true;
            if (_this.iceCandidateBuffer.length){
                _this.executeCandidateBuffer();
            }
            //s_this.createAnswer();

        }

    }

    this.onanswer = function(data){
        if (_this.pc){
            _this.pc.setRemoteDescription(new _this.SessionDescription(data["descriptor"]));
            _this.receivedDescription = true;
            if (_this.iceCandidateBuffer.length){
                _this.executeCandidateBuffer();
            }
        }
    }

    this.oncandidate = function(data){
        if (_this.pc){
            if (_this.receivedDescription)_this.pc.addIceCandidate(new _this.IceCandidate({sdpMLineIndex: data["label"], candidate: data["candidate"]}));
            else{
                _this.iceCandidateBuffer.push(data);
            }
        }
    }

    this.executeCandidateBuffer = function()
    {
        for (var i=0; i<_this.iceCandidateBuffer.length; i++){
            _this.oncandidate(_this.iceCandidateBuffer[i]);
        }
        _this.iceCandidateBuffer = [];
    }

    //переключаемся из аудио звонка в видео
    this.switchToVideo = function(noDrawVideoWindow)
    {
        if (m_callpy.m_manager) $jcallpy.chat('access_overlay');

        _this.access_equip = true;
        navigator.getUserMedia(
            { audio: true, video: {width: 1280, height: 720} },
            function(stream){
                if (m_callpy.m_manager) $jcallpy("#callpy_access_to_equip_overlay").remove();
                _this.access_equip = false;


                    if (m_callpy.m_manager && !noDrawVideoWindow)  {
                        $jcallpy.chat('start_video', true);
                    }
                    else {
                        //$jcallpy.callpy_call('start_video');
                        //if (!$jcallpy.callpy_status('api').video) {
                            $jcallpy.callpy_status('set', 'video_start', true);
                            $jcallpy('#callpy_video_chat').attr('checked', 'checked');
                        //}
                    }


                _this.receivedDescription = false;
                _this.pc.close();

                _this.pc = new _this.PeerConnection(_this.pc_config, undefined);
                //_this.stream.stop();
                _this.stream.getTracks().forEach(function(e){e.stop()});
                _this.stream = stream;

                _this.pc.addStream(_this.stream);

                _this.pc.onicecandidate = _this.gotIceCandidate;
                _this.pc.onaddstream = _this.gotRemoteStream;
                _this.pc.oniceconnectionstatechange = function () {
                    if (!_this.pc) return;
                    if ((_this.pc.iceConnectionState=="connected" || _this.pc.iceConnectionState=="completed")){
                        //if (m_callpy.m_manager) document.getElementById("callpy_webrtc_video_tag").src = URL.createObjectURL(_this.pc.getRemoteStreams()[0]);
                        //else document.getElementById("callpy_client_video").src = URL.createObjectURL(_this.pc.getRemoteStreams()[0]);
                        //if (m_callpy.m_manager) document.getElementById("callpy_webrtc_video_tag").srcObject = _this.pc.getRemoteStreams()[0];
                        //else document.getElementById("callpy_client_video").srcObject = _this.pc.getRemoteStreams()[0];
                        if (m_callpy.m_manager){
                            if (document.getElementById("callpy_webrtc_video_tag").srcObject !== undefined){
                                document.getElementById("callpy_webrtc_video_tag").srcObject = _this.pc.getRemoteStreams()[0];
                            }else{
                                document.getElementById("callpy_webrtc_video_tag").src = URL.createObjectURL(_this.pc.getRemoteStreams()[0]);
                            }
                        }else{
                            if (document.getElementById("callpy_client_video").srcObject !== undefined){
                                document.getElementById("callpy_client_video").srcObject = _this.pc.getRemoteStreams()[0];
                            }else{
                                document.getElementById("callpy_client_video").src = URL.createObjectURL(_this.pc.getRemoteStreams()[0]);
                            }
                        }
                    }
                };

                //выводим поток с камеры в локальное видеоокно, чтобы видеть себя
                //if (m_callpy.m_manager) document.getElementById("callpy_webrtc_video_self_tag").src = URL.createObjectURL(_this.stream);
                //else document.getElementById("callpy_client_video_self").src = URL.createObjectURL(_this.stream);
                //if (m_callpy.m_manager) document.getElementById("callpy_webrtc_video_self_tag").srcObject = _this.stream;
                //else document.getElementById("callpy_client_video_self").srcObject = _this.stream;

                if (m_callpy.m_manager){
                    if (document.getElementById("callpy_webrtc_video_self_tag").srcObject !== undefined){
                        document.getElementById("callpy_webrtc_video_self_tag").srcObject = _this.stream;
                    }else{
                        document.getElementById("callpy_webrtc_video_self_tag").src = URL.createObjectURL(_this.stream);
                    }
                }else{
                    if (document.getElementById("callpy_client_video_self").srcObject !== undefined){
                        document.getElementById("callpy_client_video_self").srcObject = _this.stream;
                    }else{
                        document.getElementById("callpy_client_video_self").src = URL.createObjectURL(_this.stream);
                    }
                }

                m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("call_state", {0: "video"}));

            },
            function(error) {
                _this.access_equip = false;

                if (m_callpy.m_manager) $jcallpy("#callpy_access_to_equip_overlay").remove();

                if (error.name=="DevicesNotFoundError"){

                    alert(_("Для переключения в режим видео необходима видеокамера!"));

                }else{

                    alert(_("Для переключения в режим видео необходимо разрешить доступ к видеокамере!"));

                }

            }
        );

    };

    //вызывается, когда от пира приходит сообщение, что он переключился в видео (включил свою камеру)
    //необходимо пересоздать peerConnection и отправить предложение
    this.peer_to_video = function(data)
    {

        _this.receivedDescription = false;
        _this.pc.close();
        _this.pc = new _this.PeerConnection(_this.pc_config, undefined);

        _this.pc.addStream(_this.stream);

        _this.pc.onicecandidate = _this.gotIceCandidate;
        _this.pc.onaddstream = _this.gotRemoteStream;

        _this.pc.oniceconnectionstatechange = function () {
            if (!_this.pc) return;
            if ((_this.pc.iceConnectionState=="connected" || _this.pc.iceConnectionState=="completed")){
                //if (m_callpy.m_manager) document.getElementById("callpy_webrtc_video_tag").src = URL.createObjectURL(_this.pc.getRemoteStreams()[0]);
                //else document.getElementById("callpy_client_video").src = URL.createObjectURL(_this.pc.getRemoteStreams()[0]);
                //if (m_callpy.m_manager) document.getElementById("callpy_webrtc_video_tag").srcObject = _this.pc.getRemoteStreams()[0];
                //else document.getElementById("callpy_client_video").srcObject = _this.pc.getRemoteStreams()[0];
                if (m_callpy.m_manager){
                    if (document.getElementById("callpy_webrtc_video_tag").srcObject !== undefined){
                        document.getElementById("callpy_webrtc_video_tag").srcObject = _this.pc.getRemoteStreams()[0];
                    }else{
                        document.getElementById("callpy_webrtc_video_tag").src = URL.createObjectURL(_this.pc.getRemoteStreams()[0]);
                    }
                }else{
                    if (document.getElementById("callpy_client_video").srcObject !== undefined){
                        document.getElementById("callpy_client_video").srcObject = _this.pc.getRemoteStreams()[0];
                    }else{
                        document.getElementById("callpy_client_video").src = URL.createObjectURL(_this.pc.getRemoteStreams()[0]);
                    }
                }
            }
        };
        //createOffer() необходимо вызвать тому, кто переключился в видео-режим:

        if (_this.peer_webRTCtype == _this.webRTCtype || _this.webRTCtype=="chrome"){
            m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("call_createOffer", {}));
        }else{
            //_this.createOffer();
            m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("call_createOffer", {}));
        }

        //m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("call_createOffer", {}));

        clearTimeout(_this.pingTimer);

        if (m_callpy.m_manager){
            $jcallpy.chat('on_video');
        }else if (m_callpy.m_user){
            //$jcallpy.callpy_call('on_video');
            $jcallpy.callpy_status('set', 'video_start');
        }

    };

    this.switchToAudio = function()
    {
        //_this.pc.close();
        /*
        if (_this.webRTCtype!='firefox'){
            _this.video = false;
            _this.pc.removeStream(_this.stream);
            _this.pc.addStream(_this.audiostream);
            //_this.pc.removeStream(_this.stream);
            //_this.pc.addStream(_this.stream.getAudioTracks()[0]);
            //m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("changeCallState", {0: false}));
        }else{
            _this.video = false;
            _this.pc.removeStream(_this.videostream);
        }

        _this.createOffer();
        */
        /*
        *
        *
        * пиздатая программа у нас
        *
        * */

        //if (_this.stream.getVideoTracks().length > 0) _this.stream.getVideoTracks()[0].enabled = false;


        _this.access_equip = true;
        navigator.getUserMedia(
            { audio: true, video: false },
            function(stream){
                $jcallpy("#callpy_access_to_equip_overlay").remove();
                _this.access_equip = false;
                _this.pc.close();
                _this.receivedDescription = false;

                _this.pc = new _this.PeerConnection(_this.pc_config, undefined);
                //_this.stream.stop();
                _this.stream.getTracks().forEach(function(e){e.stop()});
                _this.stream = stream;

                _this.pc.addStream(_this.stream);

                //_this.pc.addStream(_this.stream.getAudioTracks()[0]);

                _this.pc.onicecandidate = _this.gotIceCandidate;
                _this.pc.onaddstream = _this.gotRemoteStream;
                _this.pc.oniceconnectionstatechange = function () {
                    if (!_this.pc) return;
                    if ((_this.pc.iceConnectionState=="connected" || _this.pc.iceConnectionState=="completed")) {
                        //if (m_callpy.m_manager) document.getElementById("callpy_webrtc_video_tag").src = URL.createObjectURL(_this.pc.getRemoteStreams()[0]);
                        //else document.getElementById("callpy_client_video").src = URL.createObjectURL(_this.pc.getRemoteStreams()[0]);
                        //if (m_callpy.m_manager) document.getElementById("callpy_webrtc_video_tag").srcObject = _this.pc.getRemoteStreams()[0];
                        //else document.getElementById("callpy_client_video").srcObject = _this.pc.getRemoteStreams()[0];
                        if (m_callpy.m_manager){
                            if (document.getElementById("callpy_webrtc_video_tag").srcObject !== undefined){
                                document.getElementById("callpy_webrtc_video_tag").srcObject = _this.pc.getRemoteStreams()[0];
                            }else{
                                document.getElementById("callpy_webrtc_video_tag").src = URL.createObjectURL(_this.pc.getRemoteStreams()[0]);
                            }
                        }else{
                            if (document.getElementById("callpy_client_video").srcObject !== undefined){
                                document.getElementById("callpy_client_video").srcObject = _this.pc.getRemoteStreams()[0];
                            }else{
                                document.getElementById("callpy_client_video").src = URL.createObjectURL(_this.pc.getRemoteStreams()[0]);
                            }
                        }
                    }
                };

                //TODO: прерываем поток в локальном видеоокне
                document.getElementById("callpy_webrtc_video_self_tag").src = "";

                m_callpy.m_bridge.to_peer(m_callpy.m_message.create_message("call_state", {
                    "state": "audio"
                }));
                //_this.createOffer();
            },
            function(error) {
                $jcallpy("#callpy_access_to_equip_overlay").remove();
                _this.access_equip = false;
                alert(_("Ошибка")+"!");
                /*
                if (error.name=="DevicesNotFoundError"){

                    alert("Для переключения в режим видео необходима видеокамера! (© Ваш Кэп)");

                }else{

                    alert("Для переключения в режим видео необходимо разрешить доступ к видеокамере! (© Ваш Кэп)");

                }
                */

            }
        );



    }

    this.peer_to_audio = function(data)
    {
        _this.receivedDescription = false;
        _this.pc.close();
        _this.pc = new _this.PeerConnection(_this.pc_config, undefined);

        _this.pc.addStream(_this.stream);

        _this.pc.onicecandidate = _this.gotIceCandidate;
        _this.pc.onaddstream = _this.gotRemoteStream;
        _this.pc.oniceconnectionstatechange = function () {
            if (!_this.pc) return;
            if ((_this.pc.iceConnectionState=="connected" || _this.pc.iceConnectionState=="completed")){
                //if (m_callpy.m_manager) document.getElementById("callpy_webrtc_video_tag").src = URL.createObjectURL(_this.pc.getRemoteStreams()[0]);
                //else document.getElementById("callpy_client_video").src = URL.createObjectURL(_this.pc.getRemoteStreams()[0]);
                //if (m_callpy.m_manager) document.getElementById("callpy_webrtc_video_tag").srcObject = _this.pc.getRemoteStreams()[0];
                //else document.getElementById("callpy_client_video").srcObject = _this.pc.getRemoteStreams()[0];
                if (m_callpy.m_manager){
                    if (document.getElementById("callpy_webrtc_video_tag").srcObject !== undefined){
                        document.getElementById("callpy_webrtc_video_tag").srcObject = _this.pc.getRemoteStreams()[0];
                    }else{
                        document.getElementById("callpy_webrtc_video_tag").src = URL.createObjectURL(_this.pc.getRemoteStreams()[0]);
                    }
                }else{
                    if (document.getElementById("callpy_client_video").srcObject !== undefined){
                        document.getElementById("callpy_client_video").srcObject = _this.pc.getRemoteStreams()[0];
                    }else{
                        document.getElementById("callpy_client_video").src = URL.createObjectURL(_this.pc.getRemoteStreams()[0]);
                    }
                }
            }
        };
        _this.createOffer();
        clearTimeout(_this.pingTimer);
    }

    this.changeCallState = function (data){
        if (data["video"] == "true"){
            _this.video = true;
            _this.pc.removeStream(_this.audiostream);
            _this.pc.addStream(_this.stream);
        }else if (data["video"] == "false"){
            _this.video = false;
            _this.pc.removeStream(_this.stream);
            _this.pc.addStream(_this.audiostream);
        }
        _this.createOffer();
    }

    //во время состоявшегося видео звонка (хотя бы с одной стороны) включаем-выключаем камеру (любым клиентом)
    this.switchCamera = function (data){
         if (m_callpy.m_manager){
             if (_this.stream.getVideoTracks().length){ //видео-поток уже был добавлен; просто используем хак
                 _this.stream.getVideoTracks()[0].enabled = data['status'];
                 //TODO: посылаем клиенту сообщение, что "выключили" камеру (чтобы отрисовать заглушку у клиента)
                 if (!data['status']) m_callpy.m_bridge.to_peer({action: "peerDisabledCamera"});
             }else{
                 //видео-потока и не было, запрос
                 _this.switchToVideo(); //TODO: должно отличаться от переключения в видео в режиме аудио (у другого собеседника видео-поток уже есть в текущем случае)
             }
         }else{
             //TODO: у клиента - по-другому

             if (_this.stream.getVideoTracks().length){ //видео-поток уже был добавлен; просто используем хак
                 _this.stream.getVideoTracks()[0].enabled = data['status'];
                 if (!data['status']) m_callpy.m_bridge.to_peer({action: "peerDisabledCamera"});
                 else {
                     $jcallpy.callpy_status('set', 'video_start', true);
                     $jcallpy('#callpy_video_chat').attr('checked', 'checked');
                 }
             }else{
                 //видео-потока и не было, запрос
                 _this.switchToVideo(true); //TODO: должно отличаться от переключения в видео в режиме аудио (у другого собеседника видео-поток уже есть в текущем случае)
             }

         }
    }

    /*
    Screen sharing module
     */
    this.getScreenConstraints = function getScreenConstraints(error, sourceId, canRequestAudioTrack) {
        var screen_constraints = {
            audio: false,
            video: {
                mandatory: {
                    chromeMediaSource: error ? 'screen' : 'desktop',
                    maxWidth: window.screen.width > 1920 ? window.screen.width : 1920,
                    maxHeight: window.screen.height > 1080 ? window.screen.height : 1080
                },
                optional: []
            }
        };

        if(!!canRequestAudioTrack) {
            screen_constraints.audio = {
                mandatory: {
                    chromeMediaSource: error ? 'screen' : 'desktop',
                    // echoCancellation: true
                },
                optional: []
            };
        }

        if (sourceId) {
            screen_constraints.video.mandatory.chromeMediaSourceId = sourceId;

            if(screen_constraints.audio && screen_constraints.audio.mandatory) {
                screen_constraints.audio.mandatory.chromeMediaSourceId = sourceId;
            }
        }

        return screen_constraints;
    };
};